import { useMutation } from 'react-query';
import { axiosClient } from './axiosClient';

type FormData = {
  url: string;
  method: string;
  payload?: {};
  headers?: {};
};

const postFn = async <T>(formData: FormData) => {
  let response: any;

  const { url, method, payload, headers } = formData;

  if (method === 'post') {
    response = await axiosClient.post(url, payload, headers);
  } else if (method === 'put') {
    response = await axiosClient.put(url, payload, headers);
  } else if (method === 'delete') {
    response = await axiosClient.delete(url);
  }
  return response.data as Promise<T>;
};

export function usePostMutation<T>() {
  const mutation = useMutation((formData: FormData) => postFn<T>(formData));
  return mutation.mutateAsync;
}
